export const ConfigDocumentosDetalle = {
	barraBusqueda: {
		criterios: ["Razon Social", "Rut Cliente", "Folio"],
		criteriosKeys: ["razonSocialReceptor", "rutReceptor", "folio"],
		criterioPrincipal: "Folio",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Facturación Emitida",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
